import * as React from "react";

import { ViewportContext } from "@/components/viewport-provider/viewport-provider-component";

export default function useViewport() {
  return React.useContext(ViewportContext).viewport;
}
